import React from 'react';
import { IconButton } from '@atlaskit/button/new';
import AddIcon from '@atlaskit/icon/core/add';
import CloseIcon from '@atlaskit/icon/core/close';
import { useIntl } from '@atlassian/jira-intl';
import { PARTICIPANT_STATUS } from '../../../../common/constants';
import type { ParticipantActivityProps } from '../../../../common/types';
import { useStandupStore } from '../../../../controllers/store';
import messages from './messages';

export const ItemActivity = ({ id, status }: ParticipantActivityProps) => {
	const { formatMessage } = useIntl();
	const [, { toggleParticipantStatus }] = useStandupStore();

	if (status === PARTICIPANT_STATUS.NOT_PARTICIPATING) {
		return (
			<IconButton
				appearance="subtle"
				icon={AddIcon}
				label={formatMessage(messages.addParticipantNonfinal)}
				isTooltipDisabled={false}
				onClick={() => toggleParticipantStatus(id)}
			/>
		);
	}

	if (status === PARTICIPANT_STATUS.PARTICIPATING) {
		return (
			<IconButton
				appearance="subtle"
				icon={CloseIcon}
				label={formatMessage(messages.skipParticipantNonfinal)}
				isTooltipDisabled={false}
				onClick={() => toggleParticipantStatus(id)}
			/>
		);
	}

	return null;
};
